import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import ProjectSOWView from "../../../../employer/memberProposal/components/ProjectSOWView";
import ProjectSOWEdit from "../../../../candidate/project/statementOfWork/components/ProjectSOW/ProjectSOWEdit";

import * as projectActions from "../../../../../actions/project.actions";
import * as commonActions from "../../../../../actions/common.actions";
import * as dropdownsActions from "../../../../../actions/dropdowns.actions";
import * as citiesActions from "../../../../../actions/cities.actions";

class EditSowContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentPageIndex: null,
      currentMemberProjectState: null,
      project: null,
      match: null,
      pitch: null,
      sow: null,
      requestedFeedbackCheck: false,
      messagesLoaded: false
    };

    this.submitSOW = this.submitSOW.bind(this);
  }

  componentDidMount() {
    // this.props.projectActions.getProject(this.props.match.params.projectId);
    this.props.projectActions.getSOW(this.props.match.params.sowId);
    this.props.dropdownsActions.getProjectBudgetRateTypes();
    this.props.dropdownsActions.getWorkTypes();
    this.props.dropdownsActions.getTaxStatus();
  }

  submitSOW(data) {
    const sow = this.props.project.sow;

    data.city = _.get(data, "city[0].description");

    if (!data.project_flexible) data.project_flexible = false;

    if (sow)
      this.props.projectActions.updateSOW(
        sow.id,
        data,
        this.props.match.params.projectId
      );
    else {
      data.pitch_id = this.props.project.sow.pitch_id;

      this.props.projectActions.storeSOW(data);
    }
  }

  getSowComponent() {
    const {
      projectBudgetRateTypes,
      workTypes,
      taxStatus,
      cities,
      citiesActions
    } = this.props;

    const { project, currentMemberProjectState } = this.state;

    const sow = this.props.project.sow;
    const employer = _.get(project, "user");
    const member = _.get(sow, "match.member");

    const projectCompeted = _.get(project, "status.name") === "completed";
    const disabled =
      currentMemberProjectState === "matched" ||
      currentMemberProjectState === "matchPitched" ||
      projectCompeted;

    return this.state.currentMemberProjectState === "sowApproved" ? (
      <ProjectSOWView
        sowData={sow}
        member={member}
        employer={employer}
        fromMemberPage
      />
    ) : (
      <ProjectSOWEdit
        sow={sow}
        projectBudgetRateTypes={
          projectBudgetRateTypes
            ? projectBudgetRateTypes.filter(type => type.id != 78)
            : projectBudgetRateTypes
        }
        workTypes={workTypes}
        taxStatus={taxStatus}
        onSubmit={this.submitSOW}
        disabled={disabled}
        cities={cities}
        onSearchCities={citiesActions.searchCitiesAutocomplete}
      />
    );
  }

  render() {
    return this.getSowComponent();
  }
}

const mapStateToProps = state => {
  return {
    project: state.project,
    projectBudgetRateTypes: state.dropdowns.projectBudgetRateTypes.data,
    workTypes: state.dropdowns.workTypes.data,
    taxStatus: state.dropdowns.taxStatus.data,
    cities: state.cities.cities.predictions
  };
};

const mapDispatchToProps = dispatch => {
  return {
    projectActions: bindActionCreators(projectActions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
    dropdownsActions: bindActionCreators(dropdownsActions, dispatch),
    citiesActions: bindActionCreators(citiesActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditSowContainer);



// WEBPACK FOOTER //
// ./src/routes/admin/project/edit/containers/EditSowContainer.js